<div class="patientDisableDialog">
  <mat-dialog-content>
    <h3 *ngIf="data.patients.length === 1">
      {{ "page.patientlist.disablePatientConfirm" | translate }}
    </h3>
    <h3 *ngIf="data.patients.length > 1">
      {{ "page.patientlist.disablePatientPluralConfirm" | translate : { length: data.patients.length } }}
    </h3>

    <div class="disableField">
      <mat-label class="disableFieldLabel">{{ "model.patient.disablePatientType.title" | translate }}</mat-label>
      <mat-radio-group class="radioButtonRow" [value]="isPermanent" (change)="onTypeChange($event)">
        <mat-radio-button [value]="false">
          {{ "model.patient.disablePatientType.temporary" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="true">
          {{ "model.patient.disablePatientType.permanent" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="disableField">
      <mat-label class="disableFieldLabel">{{ "model.patient.disablePatientReason.title" | translate }}</mat-label>
      <mat-radio-group class="radioButtonList" [value]="selectedReason" (change)="onRadioChange($event)">
        <mat-radio-button *ngFor="let reason of simpleReasons" [value]="reason">
          {{ "model.patient.disablePatientReason." + reason | translate }}
        </mat-radio-button>
        <div class="otherReasonRow">
          <mat-radio-button [value]="reasons.OTHER">
            {{ ("model.patient.disablePatientReason." + reasons.OTHER | translate) + " :" }}
          </mat-radio-button>
          <mat-form-field class="otherReasonInput">
            <!-- No ngModel here on purpose: it would take over the disabled binding and ignore its initial value. -->
            <input
              #otherReasonInput
              matInput
              type="text"
              [disabled]="selectedReason !== reasons.OTHER"
              [value]="otherReason"
              (input)="otherReason = otherReasonInput.value"
              maxlength="30"
              placeholder="{{ 'model.patient.disablePatientReason.otherPlaceholder' | translate }}"
            />
          </mat-form-field>
        </div>
        <mat-error *ngIf="otherReasonMissing">
          {{ "model.patient.disablePatientReason.otherRequired" | translate }}
        </mat-error>
      </mat-radio-group>
    </div>

    <div class="disableField">
      <mat-form-field class="dateInput">
        <mat-label>{{ "model.patient.disablePatientType.startDate" | translate }}</mat-label>
        <input matInput [matDatepicker]="startDatePicker" [max]="maxStartDate" [(ngModel)]="startDate" (dateChange)="onStartDateChange()" />
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
        <mat-hint>{{ "model.patient.disablePatientType.startDateHint" | translate }}</mat-hint>
      </mat-form-field>
    </div>

    <div class="disableField" *ngIf="!isPermanent">
      <mat-form-field class="dateInput">
        <mat-label>{{ "model.patient.disablePatientType.endDate" | translate }}</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [min]="minEndDate" [(ngModel)]="endDate" />
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
        <mat-hint>{{ "model.patient.disablePatientType.endDateHint" | translate }}</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button cdkFocusInitial mat-dialog-close [disabled]="isSaving">
      {{ "common.no" | translate }}
    </button>
    <button mat-button color="primary" [disabled]="!canSubmit || isSaving" (click)="onYes()">{{ "common.yes" | translate }}</button>
  </mat-dialog-actions>
</div>
